import React from 'react'
import {
  HiHandThumbUp,
  HiOutlineBookOpen,
  HiOutlineBuildingOffice2,
  HiOutlineCog,
  HiOutlineCurrencyDollar,
  HiOutlineHomeModern,
  HiOutlineNewspaper,
  HiOutlinePencilSquare,
  HiOutlineQuestionMarkCircle,
  HiOutlineShieldCheck,
  HiOutlineUserCircle
} from 'react-icons/hi2'
import { LogoIcon } from '../jbda/logo'

export const navIconMap: Record<string, React.ReactNode> = {
  logo: <LogoIcon className='h-4 w-4' />,
  cog: <HiOutlineCog className='h-4 w-4 opacity-80' />,
  faq: <HiOutlineQuestionMarkCircle className='h-4 w-4 opacity-80' />,
  home: <HiOutlineHomeModern className='h-4 w-4 opacity-80' />,
  crypto: <HiOutlineCurrencyDollar className='h-4 w-4 opacity-80' />,
  regulated: <HiOutlineShieldCheck className='h-4 w-4 opacity-80' />,
  immo: <HiOutlineBuildingOffice2 className='h-4 w-4 opacity-80' />,
  blog: <HiOutlinePencilSquare className='h-4 w-4 opacity-80' />,
  about: <HiOutlineUserCircle className='h-4 w-4 opacity-80' />,
  glossary: <HiOutlineBookOpen className='h-4 w-4 opacity-80' />,
  thumbup: <HiHandThumbUp className='h-4 w-4 opacity-80' />,
  press: <HiOutlineNewspaper className='h-4 w-4 opacity-80' />
}
